<template>
    <SwipeModalComponent v-if="cardRechargeMenu.isVisible" @closeMenu="closeRechargeMenu">
        <div class="content-wrapper">
            <h2 v-text="storeName"></h2>
            <div class="recharge-value" v-if="showMinValue">
                <text>Valor mínimo</text>
                <input type="text" placeholder="R$ 0,00" maxlength="12" v-model="formattedMinValue" @input="formatValue($event, true)" />
            </div>
            <div class="recharge-value">
                <text>Valor da recarga:</text>
                <input type="text" placeholder="R$ 0,00" maxlength="12" v-model="formattedValue" @input="formatValue" />
            </div>
            <div class="buttons">
                <button v-if="showDeleteButton" class="fa fa-trash fa-2xl delete" @click="emitDelete"></button>
                <button @click="confirmValue" class="confirm">Confirmar</button>
            </div>
        </div>
    </SwipeModalComponent>
</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import { mapGetters, mapActions } from 'vuex'
import { showErrorNotification } from '@/libs/Util'
export default {
    name: 'RechargeValueComponent',
    props: ['storeName', 'showMinValue', 'initailMinValue', 'initialRechargeValue', 'showDeleteButton', 'resetAfterConfirm'],
    emits: ['updateValue', 'deleteRecharge'],
    components: {
        SwipeModalComponent
    },
    data () {
        return {
            value: '',
            formattedValue: 'R$ 0,00',
            minValue: '',
            formattedMinValue: 'R$ 0,00'
        }
    },
    computed: {
        ...mapGetters(['cardRechargeMenu'])
    },
    methods: {
        ...mapActions(['changeCardRechargeMenuVisibility']),
        emitEvent: function (item) {
            this.$emit('componentEvent', item)
        },
        formatValue (event, minValue = false) {
            const value = event.target.value.replace(/\D/g, '')
            const formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100)
            if (minValue) {
                this.minValue = value / 100
                this.formattedMinValue = formattedValue
                return
            }
            this.value = value / 100
            this.formattedValue = formattedValue
        },
        resetValues () {
            this.value = ''
            this.formattedValue = 'R$ 0,00'
            this.minValue = ''
            this.formattedMinValue = 'R$ 0,00'
        },
        confirmValue () {
            if (this.minValue > this.value) {
                showErrorNotification({
                    title: '',
                    text: 'O valor mínimo não pode ser maior que o valor da recarga.'
                })
                return
            }

            this.$emit('updateValue', this.value, this.minValue)
            if (this.resetAfterConfirm) {
                this.resetValues()
            }
        },
        closeRechargeMenu () {
            this.value = this.initialRechargeValue
            this.formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.initialRechargeValue)
            this.minValue = this.initailMinValue
            this.formattedMinValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.initailMinValue)
            this.changeCardRechargeMenuVisibility()
        },
        emitDelete () {
            this.$emit('deleteRecharge')
        }
    },
    watch: {
        initialRechargeValue (val) {
            this.value = val
            this.formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)
        },
        initailMinValue (val) {
            this.minValue = val
            this.formattedMinValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)
        }
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;

    h2 {
        text-align: center;
        &:last-of-type {
            margin-bottom: 40px;
        }
    }

    .recharge-value {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        text-align: center;

        input {
            width: 40%;
            border: 1px solid #B4B4B4;
            border-radius: 5px;
            padding: 10px 0;
            text-align: center;
            margin-top: 10px;
        }
    }

    .confirmButton {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    button {
        text-align: right;
        border-radius: 5px;
        color: var(--iconColor);
        padding: 10px;
        margin: 20px 0;
        font-weight: 600;
        border: none;
        background-color: transparent;
    }

    .buttons {
        display: flex;
        flex-direction: row;
        .delete {
            // a esquerda
            margin-right: auto;
        }

        .confirm {
            // a direita
            margin-left: auto;
            background-color: var(--buttonBackground);
            color: var(--buttonText);
        }
    }

}
</style>
